import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { SidenavService } from './layout/sidenav/sidenav.service';
import { Platform } from '@angular/cdk/platform';
import { SplashScreenService } from '../@fury/services/splash-screen.service';
import { AuthenticationService } from './services/base/authentication.service';
import { User } from './interfaces/routering/user';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppUpdateDialogComponent } from '../@fury/shared/dialog/app-update-dialog/app-update-dialog.component';
import { SnackbarService } from './services/base/snackbar.service';
import { interval, Observable } from 'rxjs';
import { LayoutService } from './layout/layout.service';
import { SidenavItem } from './layout/sidenav/sidenav-item/sidenav-item.interface';
import { environment } from '../environments/environment';

@Component({
  selector: 'fury-root',
  templateUrl: './app.component.html',
})
export class AppComponent {

  private swUpdatePending: boolean = false;

  private sidenavTopItems: SidenavItem[] = [
    {
      uniqueId: 'map-overview',
      name: 'Kaart weergave',
      routeOrFunction: '/',
      icon: 'map',
      position: 0,
      alwaysOpened: false,
      permissions: [
      ],
    },
    {
      uniqueId: 'tasks',
      name: 'Taken',
      icon: 'assignment_ind',
      position: 10,
      alwaysOpened: true,
      permissions: [
        'tasks.create',
        'tasks.update',
        'tasks.delete',
        'tasks.reopen',
        'tasks.forward',
        'tasks.print',
        'tasks.handle',
        'tasks.view.all',
        'tasks.reassign',
      ],
      subItems: [
        {
          uniqueId: 'open-tasks',
          name: 'Openstaand',
          routeOrFunction: '/taken',
          icon: 'assignment',
          position: 0,
          badgeItem: 'tasks_open',
          permissions: [
            'tasks.create',
            'tasks.update',
            'tasks.delete',
            'tasks.reopen',
            'tasks.forward',
            'tasks.print',
            'tasks.handle',
            'tasks.view.all',
            'tasks.reassign',
          ],
        },
        {
          uniqueId: 'closed-tasks',
          name: 'Gesloten',
          routeOrFunction: '/taken/gesloten',
          icon: 'assignment_turned_in',
          position: 5,
          badgeItem: 'tasks_closed',
          permissions: [
            'tasks.create',
            'tasks.update',
            'tasks.delete',
            'tasks.reopen',
            'tasks.forward',
            'tasks.print',
            'tasks.handle',
            'tasks.view.all',
          ],
        },
        {
          uniqueId: 'all-tasks',
          name: 'Alle',
          routeOrFunction: '/taken/alle',
          icon: 'assignment_turned_in',
          position: 10,
          badgeItem: 'tasks_all',
          permissions: [
            'tasks.view.all',
          ],
        },
      ]
    },
    {
      uniqueId: 'new-task',
      name: 'Nieuwe taak',
      routeOrFunction: '/taken/nieuw',
      icon: 'add_user',
      position: 20,
      alwaysOpened: false,
      permissions: [
        'tasks.create'
      ],
    },
    {
      uniqueId: 'dashboard',
      name: 'Dashboard',
      routeOrFunction: '/dashboard',
      icon: 'dashboard',
      position: 30,
      alwaysOpened: false,
      permissions: [
        'dashboard.read'
      ],
    },
    {
      uniqueId: 'control',
      name: 'BEHEER',
      position: 100,
      type: 'subheading',
      permissions: [
        'configuration.address-book.manage',
        'configuration.changelogs.manage',
        'configuration.email-templates.manage',
        'configuration.faq.manage',
        'configuration.history-types.manage',
        'configuration.holidays.manage',
        'configuration.knowledge-base.manage',
        'configuration.priorities.manage',
        'configuration.standard-reactions.manage',
        'configuration.statuses.manage',
        'configuration.currents.manage',
        'configuration.impact-registrations.manage',
        'routering.actions.manage',
        'routering.categories.manage',
        'routering.departments.manage',
        'routering.organisations.manage',
        'routering.roles.manage',
        'routering.sources.manage',
        'routering.tiles.manage',
        'routering.users.manage',
      ],
    },
    {
      uniqueId: 'routering',
      name: 'Routering',
      icon: 'call_split',
      position: 110,
      alwaysOpened: false,
      permissions: [
        'routering.actions.manage',
        'routering.categories.manage',
        'routering.departments.manage',
        'routering.organisations.manage',
        'routering.roles.manage',
        'routering.sources.manage',
        'routering.tiles.manage',
        'routering.users.manage',
      ],
      subItems: [
        {
          uniqueId: 'organisations',
          name: 'Organisatie',
          routeOrFunction: '/routering/organisatie',
          position: 0,
          permissions: [
            'routering.organisations.manage'
          ],
        },
        {
          uniqueId: 'departments',
          name: 'Afdelingen',
          routeOrFunction: '/routering/afdelingen',
          position: 5,
          permissions: [
            'routering.departments.manage',
          ],
        },
        {
          uniqueId: 'user-roles',
          name: 'Gebruikertypes',
          routeOrFunction: '/routering/gebruikertypes',
          position: 10,
          permissions: [
            'routering.roles.manage',
          ],
        },
        {
          uniqueId: 'users',
          name: 'Gebruikers',
          routeOrFunction: '/routering/gebruikers',
          position: 15,
          permissions: [
            'routering.users.manage',
          ],
        },
        {
          uniqueId: 'basis-registraties',
          name: 'Basis registraties',
          routeOrFunction: '/routering/basis-registraties',
          position: 20,
          permissions: [
            'routering.categories.manage'
          ],
        },
        {
          uniqueId: 'sources',
          name: 'Bron',
          routeOrFunction: '/routering/bron',
          position: 25,
          permissions: [
            'routering.sources.manage'
          ],
        },
        {
          uniqueId: 'actions',
          name: 'Acties',
          routeOrFunction: '/routering/acties',
          position: 30,
          permissions: [
            'routering.actions.manage'
          ],
        },
        {
          uniqueId: 'tiles',
          name: 'Tegels',
          routeOrFunction: '/routering/tegels',
          position: 35,
          permissions: [
            'routering.tiles.manage'
          ],
        },
      ]
    },
    {
      uniqueId: 'configuration',
      name: 'Instellingen',
      icon: 'settings',
      position: 120,
      alwaysOpened: false,
      permissions: [
        'configuration.address-book.manage',
        'configuration.changelogs.manage',
        'configuration.email-templates.manage',
        'configuration.faq.manage',
        'configuration.history-types.manage',
        'configuration.holidays.manage',
        'configuration.knowledge-base.manage',
        'configuration.priorities.manage',
        'configuration.standard-reactions.manage',
        'configuration.statuses.manage',
        'configuration.currents.manage',
        'configuration.impact-registrations.manage',
      ],
      subItems: [
        {
          uniqueId: 'email-templates',
          name: 'E-mail templates',
          routeOrFunction: '/instellingen/email-templates',
          position: 0,
          permissions: [
            'configuration.email-templates.manage'
          ],
        },
        {
          uniqueId: 'statuses',
          name: 'Statussen',
          routeOrFunction: '/routering/statussen',
          position: 5,
          permissions: [
            'routering.statuses.manage'
          ],
        },
        {
          uniqueId: 'standard-reactions',
          name: 'Standaard reacties',
          routeOrFunction: '/instellingen/standaard-reacties',
          position: 10,
          permissions: [
            'configuration.standard-reactions.manage'
          ],
        },
        {
          uniqueId: 'address-book',
          name: 'Adressenboek',
          routeOrFunction: '/instellingen/adressenboek',
          position: 15,
          permissions: [
            'configuration.address-book.manage'
          ],
        },
        {
          uniqueId: 'knowledge-base-section',
          name: 'Handleiding',
          position: 20,
          alwaysOpened: false,
          permissions: [
            'configuration.knowledge-base.manage',
            'configuration.faq.manage',
            'configuration.changelogs.manage',
          ],
          subItems: [
            {
              uniqueId: 'knowledge-base',
              name: 'Handleiding',
              routeOrFunction: '/instellingen/handleiding',
              position: 0,
              permissions: [
                'configuration.knowledge-base.manage',
              ]
            },
            {
              uniqueId: 'faq',
              name: 'FAQ',
              routeOrFunction: '/instellingen/handleiding/faq',
              position: 5,
              permissions: [
                'configuration.faq.manage',
              ]
            },
            {
              uniqueId: 'contact-details',
              name: 'Contact gegevens',
              routeOrFunction: '/instellingen/handleiding/contact-gegevens',
              position: 10,
              permissions: []
            },
            {
              uniqueId: 'application-updates',
              name: 'Update applicatie',
              position: 15,
              routeOrFunction: '/instellingen/handleiding/update-applicatie',
              permissions: [
                'configuration.changelogs.manage',
              ],
            },
            {
              uniqueId: 'application-update-types',
              name: 'Update applicaties types',
              routeOrFunction: '/instellingen/handleiding/update-applicatie/types',
              position: 20,
              permissions: [
                'configuration.changelogs.types.manage',
              ],
            },
          ],
        },
        {
          uniqueId: 'priorities',
          name: 'Prioriteiten',
          routeOrFunction: '/instellingen/prioriteiten',
          position: 25,
          permissions: [
            'configuration.priorities.manage',
          ],
        },
        {
          uniqueId: 'currents',
          name: 'Stroms',
          routeOrFunction: '/instellingen/stroms',
          position: 26,
          permissions: [
            'configuration.currents.manage',
          ],
        },
        {
          uniqueId: 'impact-registrations',
          name: 'Invloed registraties',
          routeOrFunction: '/instellingen/invloed-registraties',
          position: 27,
          permissions: [
            'configuration.impact-registrations.manage',
          ],
        },
        {
          uniqueId: 'history-types',
          name: 'Geschiedenis',
          routeOrFunction: '/instellingen/geschiedenis',
          position: 30,
          permissions: [
            'configuration.history-types.manage',
          ],
        },
        {
          uniqueId: 'holidays',
          name: 'Feestdagen',
          routeOrFunction: '/instellingen/feestdagen',
          position: 35,
          permissions: [
            'configuration.holidays.manage',
          ]
        },
      ]
    },
    {
      uniqueId: 'sent-emails',
      name: 'Sent Emails',
      routeOrFunction: '/sent-emails',
      icon: 'email',
      position: 130,
      alwaysOpened: false,
      permissions: [
        'sent-emails.logs'
      ],
    },
  ];
  private sidenavBottomItems: SidenavItem[] = [
    {
      uniqueId: 'help-and-support',
      name: 'Help & support',
      routeOrFunction: '/handleiding',
      icon: 'help_outline',
      position: 0
    },
  ];

  constructor(private sidenavService: SidenavService,
              private iconRegistry: MatIconRegistry,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: Document,
              private platform: Platform,
              private splashScreenService: SplashScreenService, // required!! otherwise splashScreen does not go away on an app load
              private authenticationService: AuthenticationService,
              private swUpdate: SwUpdate,
              private dialogService: MatDialog,
              private snackbarService: SnackbarService,
              private layoutService: LayoutService,
  ) {
    this.renderer.addClass(this.document.body, 'fury-default');
    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    if (this.swUpdate.isEnabled) {
      const oncePerHour$: Observable<number> = interval(360 * 1000);

      oncePerHour$.subscribe((): Promise<void> => this.swUpdate.checkForUpdate()
        .then((): void => console.log('checkForUpdate()'))
        .catch((error): void => {
          console.log('Service worker isn\'t supported or disabled!');
          throw new Error(error);
        }));

      this.swUpdate.versionUpdates.subscribe((event: VersionEvent): void => {
        if (!this.swUpdatePending) {
          if (event.type === 'VERSION_DETECTED') {
            this.snackbarService.info('Er is een nieuwe versie van de applicatie beschikbaar die op de achtergrond wordt klaargezet.');
          }
          if (event.type === 'VERSION_READY') {
            this.swUpdatePending = true;
            let dialogRef: MatDialogRef<AppUpdateDialogComponent>;
            dialogRef = this.dialogService.open(AppUpdateDialogComponent, {
              disableClose: true
            });
            dialogRef.afterClosed().subscribe(response => {
              if (response === true) {
                this.swUpdate.activateUpdate().then((): void => {
                  window.location.reload();
                });
              } else {
                this.layoutService.appUpdatePending = true;
                this.layoutService.updateApp.subscribe((): void => {
                  this.swUpdate.activateUpdate().then((): void => {
                    window.location.reload();
                  });
                });
              }
            });
          }
        }
      });
    }

    this.authenticationService.user$.subscribe((user: User): void => {
      if (!user) {
        if (!environment.production) {
          console.log('Sidenav: no user, clearing items');
        }
        this.sidenavService.items = [];
      }

      if (user) {
        if (!environment.production) {
          console.log('Sidenav: user propagated, adding or updating menu items');
        }
        this.sidenavService.addItems(this.sidenavTopItems);
        this.sidenavService.addItemsBottom(this.sidenavBottomItems);
      }
    });
  }
}
